/* ═══════════════════════════════════════════════════════════════
   refLink — bawa kod ejen (?ref=) merentas domain DAN merentas browser.

   KENAPA WUJUD (bug iOS, disahkan 2026-07-28):
   sesaat.ai dan app.sesaat.ai ialah dua origin berasingan — localStorage
   TAK dikongsi langsung, dan cookie pula hilang bila pelanggan bertukar
   browser. Kes paling kerap: pelanggan klik link ejen dalam WhatsApp →
   iOS buka dalam browser mini WhatsApp (kotak cookie sendiri) → pelanggan
   tekan "Open in Safari" → Safari tak nampak apa-apa yang disimpan tadi.
   Android jarang kena sebab Chrome Custom Tab kongsi kotak cookie Chrome.

   Satu-satunya benda yang selamat merentas pindah tu ialah kod ejen yang
   duduk DALAM alamat URL itu sendiri. Sebab tu App.jsx tak lagi memadam
   ?ref= dari alamat, dan setiap lompatan sesaat.ai → app.sesaat.ai kena
   bawa kod ejen guna withRef().
   ═══════════════════════════════════════════════════════════════ */

/** Kod ejen aktif. Cookie didahulukan (App.jsx dah kanonkan customSlug → refCode);
 *  alamat URL jadi jaring terakhir bila cookie/storage disekat atau browser bertukar. */
export function getActiveRef() {
    try {
        const match = document.cookie.match(/(?:^|;\s*)sesaat_ref=([^;]*)/);
        if (match) return decodeURIComponent(match[1]);
    } catch (_) { /* cookie disekat — cuba sumber seterusnya */ }
    try {
        const stored = localStorage.getItem('sesaat_ref');
        if (stored) return stored;
    } catch (_) { /* storage disekat (Private Browsing) */ }
    try {
        return new URLSearchParams(window.location.search).get('ref') || null;
    } catch (_) {
        return null;
    }
}

/** Sisip ?ref= pada URL app.sesaat.ai bila ada kod ejen.
 *  Selamat hantar customSlug ATAU refCode — server resolve kedua-duanya
 *  (findAffiliateBySlug: customSlug → refCode → customSlugHistory). */
export function withRef(url) {
    const ref = getActiveRef();
    if (!ref) return url;
    return `${url}${url.includes('?') ? '&' : '?'}ref=${encodeURIComponent(ref)}`;
}
